import React from 'react';
import st from './index.scss';
import { Icon } from '@/components';
import cn from 'classnames';

/**
 * checkboxList: 当前单选信息
 * selectCheckbox: 当前选择值，数组类型
 * setCheckbox: 点击checkbox回调，回调参数为处理过后的数组
 * checkboxType: 多选框样式类型
 */
export default function Checkbox({
  checkboxList,
  selectCheckbox = [],
  setCheckbox,
  checkboxType = 1,
  className,
}) {

  function checkboxChange(item) {
    // 数组截取的时候不去操作原有数组
    let selectCheckboxCopy = JSON.parse(JSON.stringify(selectCheckbox))
    const index = selectCheckboxCopy.indexOf(item.value);
    let selectList = (index > -1 ? selectCheckboxCopy.filter((temp, i) => i != index ) : [...selectCheckboxCopy, item.value]);
    setCheckbox && setCheckbox(selectList);
  }

  return checkboxList?.map((item, index) => {
    return checkboxType == 1 ? (
      <div
        key={index}
        className={cn(st['checkbox-1'], className)}
        onClick={()=>{
          checkboxChange(item)
        }}
      >
        <Icon
          className={cn({
            [st['checkbox-icon']]: true,
            [st['active-checkbox-icon']]: selectCheckbox?.includes(item.value),
          })}
          name={selectCheckbox?.includes(item.value) ? 'yixuanzhong' : 'weixuanzhong'}
        />
        <span>{item?.label}</span>
      </div>
    ) : (
      <div
        key={index}
        className={cn({
          [st['checkbox-2']]: true,
          [st['checkbox-2-active']]: selectCheckbox?.includes(item.value),
          [className]: true,
        })}
        onClick={()=>{
          checkboxChange(item)
        }}
      >
        <span>{item?.label}</span>
      </div>
    );
  });
}
